import {
	formatMessageCalendarDay,
	formatMessageClock,
	isMessageSameLocalDay,
	isMessageYesterday,
	toDateFromApi,
} from "./dateTimeFormat";

export function getStatusPostedLabel(ticket, businessTimeZone) {
	const lastUpdate =
		ticket.lastMessageObj?.createdAt || ticket.updatedAt;
	const date = toDateFromApi(lastUpdate, businessTimeZone);
	if (!date) return "";

	if (isMessageSameLocalDay(date, new Date(), businessTimeZone)) {
		return `Postado hoje às ${formatMessageClock(date, businessTimeZone)}`;
	}
	if (isMessageYesterday(date, new Date(), businessTimeZone)) {
		return "Postado ontem";
	}
	return `Postado em ${formatMessageCalendarDay(date, businessTimeZone)}`;
}

export function getStatusMediaLabel(ticket) {
	const mediaType = ticket.lastMessageObj?.mediaType;
	if (mediaType === "video") return "Vídeo";
	if (mediaType === "image") return "Foto";
	if (mediaType === "chat") return "Texto";
	return "Status";
}
